<template>
  <div class="seatsio seatsio-general-container tickets section">
    <h2 v-if="title" class="title">
      {{
        event.channel?.channel === CHANNEL_ID_HERBALIFE
          ? $t("wegow.purchase.seatsio.selectTicket")
          : $t("wegow.purchase.seatsio.buyTickets")
      }}
    </h2>
    <div class="container-seatsio flex flex-col items-center">
      <div id="container-seatsio-widget" class="container" />
      <!-- <div
        v-if="event.authorization_file_url || event.access_policy"
        class="mT20"
      >
        <div v-if="event.authorization_file_url" cols="12">
          <a
            :href="event.authorization_file_url"
            :title="event.authorization_file_url"
            :style="`color: ${iframe ? iframe.font_color : ''}`"
            target="_blank"
          >
            <p
              :style="`color: ${iframe ? iframe.font_color : ''}`"
              class="help-text m0"
            >
              {{ $t("tickets.descargarAutorizacionParaMenores") }}
            </p>
          </a>
        </div>
        <div v-if="event.access_policy" cols="12">
          <text-truncate :color="iframe ? iframe.font_color : ''">
            <p
              style="display: none;"
              :style="`color: ${iframe ? iframe.font_color : ''}`"
              v-html="descriptionHTML"
            ></p>
          </text-truncate>
        </div>
      </div> -->
      <div class="error-message">{{ error }}</div>
      <div class="container-actions">
        <div class="container-actions-items">
          <!-- TODO: revisar terminos y condiciones -->
          <!-- <div class="mT20 mB20">
            <fieldset
              v-if="!!event.promoter_newsletter_option"
              id="purchase-newsletter-group"
              class="mT10 w100 form-group"
            >
              <div class="custom-control custom-checkbox">
                <input
                  id="purchase-newsletter"
                  v-model="promoter_newsletter"
                  type="checkbox"
                  name="purchase-newsletter"
                  class="custom-control-input"
                />
                <label
                  for="purchase-newsletter"
                  class="custom-control-label"
                  :style="
                    `color: ${
                      event.iframe
                        ? event.iframe.aux_font_color || event.iframe.font_color
                        : ''
                    }`
                  "
                >
                  {{
                    $t("tickets.newsletter", {
                      promoter_newsletter_text: event.promoter_newsletter_text
                    })
                  }}
                </label>
              </div>
            </fieldset>
            <fieldset
              v-if="!!event.promoter_terms_option"
              id="purchase-terms-group"
              class="mT10 w100 form-group"
            >
              <div class="custom-control custom-checkbox">
                <input
                  id="purchase-terms"
                  v-model="promoter_terms"
                  type="checkbox"
                  name="purchase-terms"
                  class="custom-control-input"
                />
                <label
                  for="purchase-terms"
                  class="custom-control-label"
                  :style="
                    `color: ${
                      event.iframe
                        ? event.iframe.aux_font_color || event.iframe.font_color
                        : ''
                    }`
                  "
                  v-html="
                    $t('tickets.promoter_terms', {
                      promoter_terms_text: event.promoter_terms_text
                    })
                  "
                />
              </div>
            </fieldset>
          </div> -->
          <div class="mt-8 space-x-4 flex justify-center">
            <!-- TODO: revisar si puede fallar por esto -->
            <wegow-button
              id="clear-select-button"
              background="opacity"
              :text="$t('wegow.purchase.seatsio.clear')"
              color="topaz-light"
              type="button"
              @click="clearSelection()"
            />
            <wegow-button
              id="purchase-seatsio-button"
              background="opacity"
              :disabled="!showButton || invalidate"
              :text="
                event.channel?.channel === CHANNEL_ID_HERBALIFE
                  ? $t('wegow.purchase.seatsio.access')
                  : $t('wegow.purchase.seatsio.buy')
              "
              color="topaz-light"
              type="button"
              @click="manage()"
            />
            <!-- <button
              type="button"
              class="btn transparent m10"
              @click="clearSelection()"
            >
              {{ $t("wegow.purchase.seatsio.clear") }}
            </button>
            <button
              type="button"
              :disabled="
                (!promoter_terms && !!event.promoter_terms_option) ||
                  !showButton ||
                  invalidate
              "
              class="btn opacity m10"
              @click="manage()"
            >
              {{
                event.channel && event.channel.channel === CHANNEL_ID_HERBALIFE
                  ? $t("wegow.purchase.seatsio.access")
                  : $t("wegow.purchase.seatsio.buy")
              }}
            </button> -->
          </div>
        </div>
      </div>
    </div>
    <wegow-loader v-if="loading" />
  </div>
</template>

<script setup>
import { useUser } from "@/composables/useUser";
import { useEvent } from "@/composables/useEvent";
import { usePurchase } from "@/composables/usePurchase";
import { useModalHandler } from "@/plugins/useModalHandler";

import WegowButton from "@/components/general/forms/WegowButton";
import WegowLoader from "@/components/general/ui/WegowLoader";

import { SEATSIOCONFIG, CHANNEL_ID_HERBALIFE } from "@/constants.js";
import { formatCurrency } from "@/plugins/currency";
import { useI18n } from "vue-i18n";
import { computed, onMounted, ref } from "vue";

const { t } = useI18n();

const { openErrorModal } = useModalHandler();
const { isAuth } = useUser();
const {
  isIframe,
  details: event,
  accessCode,
  tickets,
  configSeatsio,
  minTickets,
  available,
  pair,
  getSeatsioConfig,
  getDetails,
  getSeatsioTickets
} = useEvent();

const {
  seatsioData,
  maxNumberTicketByCode,
  setSeatsioData,
  createPurchase,
  cleanCategoryLabel
} = usePurchase();

const props = defineProps({
  title: {
    type: Boolean,
    default: true
  },
  iframe: {
    type: Object,
    default: () => {}
  },
  singlesSelected: {
    type: Number,
    default: 0
  }
});

const selectedSeats = ref([]);
const chart = ref({});
const showButton = ref(false);
const invalidate = ref(false);
const loading = ref(false);
const error = ref("");

const ticketsTypes = computed(() => {
  const selectTypes = {};
  selectedSeats.value.forEach(item => {
    if (selectTypes[item.category]) {
      selectTypes[item.category] += 1;
    } else {
      selectTypes[item.category] = 1;
    }
  });
  return tickets.value.filter(item => !!selectTypes[item.external_id]);
});

const descriptionHTML = computed(() => {
  return event.value.access_policy.replace(/\n/g, "<br>");
});

onMounted(() => {
  let places = props.singlesSelected > 0 ? props.singlesSelected : undefined;
  getConfig(places);
  getSeatsioTickets(places);
  // this.$root.$on("purchaseLoading", status => {
  //   loading.value = status;
  // });
});

const validateMaxTicketsAccessCode = () => {
  if (maxNumberTicketByCode.value === -1) {
    return false;
  }
  return selectedSeats.value.length > maxNumberTicketByCode.value;
};
const validateExactTicketsAccessCode = () => {
  if (maxNumberTicketByCode.value === -1) {
    return false;
  }
  return selectedSeats.value.length !== maxNumberTicketByCode.value;
};
const validateMinTickets = () => {
  const selectTypes = {};
  selectedSeats.value.forEach(item => {
    if (selectTypes[item.category]) {
      selectTypes[item.category] += 1;
    } else {
      selectTypes[item.category] = 1;
    }
  });
  const keys = Object.keys(selectTypes);
  for (const key of keys) {
    if (selectTypes[key] < minTickets.value[key]) {
      return false;
    }
  }
  return true;
};
const validateAvailable = () => {
  const selectTypes = {};
  selectedSeats.value.forEach(item => {
    if (selectTypes[item.category]) {
      selectTypes[item.category] += 1;
    } else {
      selectTypes[item.category] = 1;
    }
  });
  const keys = Object.keys(selectTypes);
  for (const key of keys) {
    if (selectTypes[key] > available.value[key]) {
      return false;
    }
  }
  return true;
};
const validatePair = () => {
  const selectTypes = {};
  selectedSeats.value.forEach(item => {
    if (selectTypes[item.category]) {
      selectTypes[item.category] += 1;
    } else {
      selectTypes[item.category] = 1;
    }
  });
  const keys = Object.keys(selectTypes);
  for (const key of keys) {
    if (pair.value[key] && selectTypes[key] % 2 !== 0) {
      return false;
    }
  }
  return true;
};
const manage = async () => {
  if (event.value.access_code_needed) {
    if (
      event.value.channel?.channel === CHANNEL_ID_HERBALIFE &&
      validateExactTicketsAccessCode()
    ) {
      openErrorModal({
        modal: {
          title: t("wegow.purchase.seatsio.selectTicketsErrorTitle"),
          description: t("wegow.purchase.seatsio.exactTicketError", {
            seats: maxNumberTicketByCode.value
          }),
          btn_message: t("wegow.error.accept")
        }
      });
      return;
    } else if (validateMaxTicketsAccessCode()) {
      openErrorModal({
        modal: {
          title: t("wegow.purchase.seatsio.selectTicketsErrorTitle"),
          description: t("wegow.purchase.seatsio.maxTicketError", {
            seats: maxNumberTicketByCode.value
          }),
          btn_message: t("wegow.error.accept")
        }
      });
      return;
    }
  }
  if (!validateMinTickets()) {
    showAdviseSeats();
    return;
  }
  if (!validateAvailable()) {
    showAdviseSeats();
    return;
  }
  if (!validatePair()) {
    showAdviseSeats();
    return;
  }

  setSeatsioData(JSON.parse(JSON.stringify(selectedSeats.value || {})));

  // Aqui en el antiguo se revisa si hay entradas nominativas pero en v4 se revisa en el pago
  // El resto de comprobacionas tambien se hacern en el CreatePurchase

  cleanCategoryLabel();
  loading.value = true;
  await createPurchase();
  loading.value = false;
};
const showAdviseSeats = () => {
  let text = "<p>" + t("wegow.purchase.advise.minimoEntradas") + "</p><ul>";
  for (const ticket of ticketsTypes.value) {
    text +=
      "<li> ->" +
      t("wegow.purchase.advise.entradasTipo", {
        title: ticket.title,
        min: ticket.min_tickets
      }) +
      t("wegow.purchase.advise.entradasDisponible", {
        available: ticket.available
      }) +
      (ticket.pair ? t("wegow.purchase.advise.entradasPair") : "") +
      "</li>";
  }
  text += "</ul>";

  openErrorModal({
    modal: {
      description: text,
      btn_message: t("wegow.error.accept")
    }
  });
};

const clearSelection = () => {
  chart.value.clearSelection(() => {
    selectedSeats.value = [];
  });
};
const getConfig = async places => {
  await getSeatsioConfig(places);
  // if (event.value.ticket_distributions.length > 0) {
  //   await this.$store.dispatch("seatsio/config", {
  //     ticket_dist: event.value.ticket_distributions[0].id,
  //     places: props.singlesSelected > 0 ? props.singlesSelected : undefined
  //   });
  // }

  getScript();
};
const getScript = async () => {
  const script = document.createElement("script");
  script.src = configSeatsio.value.widget;
  script.async = true;

  script.onload = () => {
    createIframe();
    // El script ha sido cargado exitosamente
    // Puedes acceder a sus variables o funciones según sea necesario
  };

  script.onerror = error => {
    // Ocurrió un error al cargar el script
    console.error("Error al cargar el script:", error);
  };

  document.head.appendChild(script);
};
const createIframe = () => {
  let config = configSeatsio.value;
  let seatsioConfig = Object.assign({}, SEATSIOCONFIG, {
    divId: "container-seatsio-widget",
    publicKey: config.public_key,
    event: event.value.ticket_distributions[0].external_id,
    consecutive_seats: event.value.ticket_distributions[0].consecutive_seats,
    no_orphan_seats: event.value.ticket_distributions[0].no_orphan_seats,
    cursorTooltip: {
      showAvailability: config.show_availability
    },
    mobileTooltip: {
      showAvailability: config.show_availability
    },
    language: config.language,
    holdToken: config.hold_token.hold_token,
    showLegend: config.show_legend,
    selectionValidators: config.selection_validators,
    onSelectionValid: () => {
      error.value = "";
      invalidate.value = false;
    },
    onSelectionInvalid: violations => {
      error.value = "";
      if (violations.includes("noOrphanSeats")) {
        invalidate.value = true;
      } else if (violations.includes("consecutiveSeats")) {
        error.value = t("wegow.purchase.seatsio.consecutiveError");
        invalidate.value = true;
      } else {
        invalidate.value = false;
      }
    },
    pricing: config.pricing,
    priceFormatter: price => {
      return formatCurrency(price, config.currency);
    },
    onObjectSelected: object => {
      objectSelected(object);
      refreshButton(true);
    },
    onObjectDeselected: object => {
      objectDeselected(object);
      refreshButton(selectedSeats.value.length > 0);
    }
  });
  if (config.numberofplacestoselect) {
    seatsioConfig.numberOfPlacesToSelect = parseInt(
      config.numberofplacestoselect
    );
  } else {
    seatsioConfig.maxSelectedObjects = config.max_selected_objects;
  }
  chart.value = new window.seatsio.SeatingChart(seatsioConfig).render();
};
const objectSelected = object => {
  var seat = {
    external_id: object.id,
    labels: object.labels,
    category: object.category.key,
    category_label: object.category.label
  };
  selectedSeats.value.push(seat);
};
const objectDeselected = object => {
  let already_found = false; // in GA zones object_id is always the same. Exclude only once
  selectedSeats.value = selectedSeats.value.filter((item, index) => {
    if (item.external_id === object.id && !already_found) {
      already_found = true;
      return false;
    } else {
      return true;
    }
  });
};
const refreshButton = value => {
  showButton.value = value;
};
</script>
<style lang="scss">
.seatsio-general-container {
  h2.title {
    padding: 10px 0 10px 40px;
    background-color: $grisdetallesopacity;
    font-size: 22px;
    letter-spacing: 1px;
  }
  .error-message {
    color: red;
    display: flex;
    justify-content: space-around;
  }
  .container-seatsio {
    position: relative;
    width: 100%;
    padding: 20px 30px;
    padding-bottom: 150px;
    @media screen and (min-width: $screen-md) {
      padding-bottom: 80px;
    }
    &.modal {
      height: calc(100vh - 200px);
      max-height: calc(100vh - 200px);
    }
    .container-actions {
      width: 100%;
      justify-content: center;
      display: flex;
      .container-actions-items {
        min-width: 470px;
        @media screen and (max-width: $screen-md) {
          min-width: initial;
        }
      }
    }
  }
}
</style>
